import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { formatDisplayDate, pnlDeduction, formatAmount, unapprovedWeekMap } from '../../helper';
import SectionHeader from '../../Pages/admin/shared/SectionHeader';
import NotApprovedTag from '../../Pages/admin/shared/NotApprovedTag';

class ByWeek extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        let { ReportDetails } = this.props;
        const unapproved = unapprovedWeekMap(this.props.UnapprovedWeeks);
        return (
            <div>
                {ReportDetails.Weeks.map((rd, index) => {
                    return (
                        <section key={index}>
                            <SectionHeader title={<>{formatDisplayDate(rd.ToFromDate[0])} - {formatDisplayDate(rd.ToFromDate[6])}<NotApprovedTag info={unapproved.get(rd.WeekNumberB)} /></>} />
                            {rd.shopsForReport.length === 0 && (
                                // Added only for its "Not approved" marker — no approved sale (T1.35).
                                <div style={{ textAlign: 'center', padding: '14px 10px', color: '#64748b', fontSize: 13, border: '1px dashed #e5e7eb', borderRadius: 8, background: '#fafafa' }} >No approved weekly sale this week for the selected shops</div>
                            )}
                            <Row style={{ justifyContent: 'center' }} >
                                {rd.shopsForReport.map((mapItem, mapIndex) => {
                                    return (
                                        <Col md={6} key={mapIndex} >
                                            <div style={{ padding: '10px', textAlign: 'center' }} ><strong style={{ color: "#d04e4a" }} >{mapItem.ShopName}</strong></div>
                                            <Paper>
                                                <TableContainer className="report-table-container" >
                                                    <Table className="report-table" size="small" aria-label="a dense table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Date & Day</TableCell>
                                                                <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Cash</TableCell>
                                                                <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Card</TableCell>
                                                                <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Other</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {mapItem?.WeeklySale?.map((x, idx) => {
                                                                return (
                                                                    <TableRow
                                                                        className="table-rows"
                                                                        key={idx}
                                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                    >
                                                                        <TableCell className="report-label-cell" >{formatDisplayDate(x.DateAndDay)}</TableCell>
                                                                        <TableCell>{formatAmount(x.Cash)}</TableCell>
                                                                        <TableCell>{formatAmount(x.Card)}</TableCell>
                                                                        <TableCell>{formatAmount(x.Others)}</TableCell>
                                                                    </TableRow>
                                                                )
                                                            })}
                                                            <TableRow
                                                                className="table-rows"
                                                                style={{ background: '#e7e7e7' }}
                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                            >
                                                                <TableCell>Total</TableCell>
                                                                <TableCell><strong>{formatAmount(mapItem.WS_Cash)}</strong></TableCell>
                                                                <TableCell><strong>{formatAmount(mapItem.WS_Card)}</strong></TableCell>
                                                                <TableCell><strong>{formatAmount(mapItem.WS_Other)}</strong></TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Paper>
                                            <div style={{ float: 'right' }} >
                                                <span style={{ color: '#d04e4a' }} >Total Sale: </span>{formatAmount(+mapItem.WS_Cash + +mapItem.WS_Card + +mapItem.WS_Other)}
                                            </div>
                                            <Paper>
                                                <TableContainer className="report-table-container" >
                                                    <Table className="report-table" size="small" aria-label="a dense table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >SrNo</TableCell>
                                                                <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Description</TableCell>
                                                                <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Amount</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {mapItem?.WeeklySaleExpense?.map((x, idx) => {
                                                                if (x.amount === 0) return "";
                                                                return (
                                                                    <TableRow
                                                                        className="table-rows"
                                                                        key={idx}
                                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                    >
                                                                        <TableCell>{idx + 1}</TableCell>
                                                                        <TableCell>{x.description}</TableCell>
                                                                        <TableCell>{formatAmount(x.amount)}</TableCell>
                                                                    </TableRow>
                                                                )
                                                            })}
                                                            <TableRow
                                                                className="table-rows"
                                                                style={{ background: '#e7e7e7' }}
                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                            >
                                                                <TableCell>Total</TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell><strong>{formatAmount(mapItem.WS_OtherExp)}</strong></TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Paper>
                                            <div style={{ padding: '5px', float: 'right', textAlign: 'right', lineHeight: 1.6 }} >
                                                {/* The 25% is DISPLAY ONLY (helper.js PNL_RENDER_DEDUCTION).
                                                    WS_PRO_LOS itself is never touched, and the deduction is
                                                    derived from the stored figure. Literal in both
                                                    directions by decision: a loss shrinks by a quarter too.
                                                    One line, two figures, on the user's instruction
                                                    2026-10-14 (was three stacked rows). */}
                                                <div>
                                                    <span style={{ color: '#4842a7' }} >P/L: </span>{formatAmount(mapItem.WS_PRO_LOS)}
                                                    <span style={{ color: '#94a3b8', margin: '0 10px' }} >|</span>
                                                    <span style={{ color: '#4842a7' }} >0.25: </span>{formatAmount(pnlDeduction(mapItem.WS_PRO_LOS))}
                                                </div>
                                            </div>
                                        </Col>
                                    )
                                })
                                }
                            </Row>
                        </section>
                    )
                })}
            </div>
        );
    }
}

export default ByWeek;